import React from 'react';
import {connect} from 'react-redux';

import {t, dt} from 'l10n';
import AutoSuggest from 'components/autosuggest/AutoSuggest';
import AutoSuggestDataProvider from 'containers/member/AutosuggestDataProvider';
import ModalBecomeXXL from 'components/modals/ModalBecomeXXL';

import {blackListUser} from 'reducers/member';

class BlackListForm extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            user: null,
            error: null,
            pending: false,
            showModal: false,
            blockedReason: '',
            blockedType: '24h',
        };

        this.handleFormInput = this.handleFormInput.bind(this);
        this.onAddButtonClick = this.onAddButtonClick.bind(this);
    }

    onAddButtonClick(e) {
        e.preventDefault();

        const {currentUser, dispatch} = this.props;

        if (!currentUser.isXXL()) {
            this.setState({showModal: true});
            return;
        }

        const {
            user,
            blockedType,
            blockedReason,
        } = this.state;

        this.setState({
            pending: true,
            error: null
        });

        let action = blackListUser(user.id, user, blockedReason, blockedType);

        dispatch(action);

        action.promise
            .then(() => this.setState({
                user: null, 
                pending: false,
                blockedReason: '',
                blockedType: '24h',
            }))
            .catch((e) => this.setState({error: e.message, pending: false}))
    }

    handleFormInput(e) {
        let target = e.target;

        this.setState({
            [target.name]: target.value
        });
    }

    render() {
        const {
            user,
            error,
            pending, 
            showModal,
            blockedType,
            blockedReason,
        } = this.state;

        const {currentUser} = this.props;

        const dataProvider = new AutoSuggestDataProvider();

        return (
            <div className="blackList">
                <ModalBecomeXXL show={showModal} closeFn={() => this.setState({showModal: false})}/>
                {error && <p className="error">{error}</p>}
                <form>

                    <div>
                        <p>{t('User')}</p>
                        <AutoSuggest
                            placeholder={t('Enter nick of the user')}
                            dataProvider={dataProvider}
                            onSelect={(item) => this.setState({user: item})}
                            value={user ? user.nick : ''}
                        />
                    </div>

                    <div className="blockTime">
                        <p>{t('Blocking duration')}</p>
                        <select name="blockedType" value={blockedType} onChange={this.handleFormInput}>
                            <option value="24h">{`24 ${t('hours')}`}</option>
                            <option value="permanent">{t('Permanent')}</option>
                        </select>
                    </div>

                    <div className="reason">
                        <p>{t('Reason')}</p>
                        <input 
                            type="text" 
                            name="blockedReason" 
                            className="reason__input"
                            placeholder={t('Describe your reason')}
                            value={blockedReason ? blockedReason : ''}
                            maxLength={500}
                            onChange={this.handleFormInput}                          
                        />
                    </div>

                    <div className="button-block">
                        <div>
                            <button
                                type="submit"
                                className={'ui-button primary btn-submit ' + (pending ? 'loading' : '')}
                                disabled={user && !pending && user.id !== currentUser.id ? null : 'disabled'}
                                onClick={this.onAddButtonClick}
                            >
                                {pending ? t('Please wait...') : t('Add')}
                            </button>
                        </div>
                    </div>

                </form>
            </div>
        )
    }
}

export default connect(
    (state) => ({
        currentUser: state.currentUser
    }),
    null
)(BlackListForm);


// WEBPACK FOOTER //
// ./src/containers/member/blackList/BlackListForm.js